import { isEmpty, isNil } from 'lodash';
import { PM60, useFeatureFlag } from '@shared/util/featureFlags/launchDarkly';

interface UseIsNeverEnabledProps {
  minimumInSeries?: number;
  tagFilter?: MBAPI.FilterByComponent;
}

export function useIsNeverEnabled({ minimumInSeries, tagFilter }: UseIsNeverEnabledProps): boolean {
  const isPM60Enabled = useFeatureFlag(PM60);

  const hasTagFilter = !isEmpty(tagFilter?.componentId);

  return isPM60Enabled && !isNil(minimumInSeries) && hasTagFilter;
}
